import { AnimatedAxis as VxAnimatedAxis } from '@visx/react-spring';
import BaseAxis from "./BaseAxis.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default function AnimatedAxis(props) {
  return /*#__PURE__*/_jsx(BaseAxis, {
    AxisComponent: VxAnimatedAxis,
    ...props
  });
}